module.exports = __webpack_public_path__ + "media/images/icon__matchdayNavigation--pagination--arrow-93809498aa38b3569dd0d00544941dc7.png";